import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "722bcb9a-e4a9-49a0-9b37-12c4f0e0b237",
    content: "Sound 1",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/05/06/task/sound-1.wav` },
  },
  {
    id: "8951ee3c-0ba3-4dea-9ee3-61f577cc5980",
    content: "Sound 2",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/05/06/task/sound-2.wav` },
  },
  {
    id: "57484a4d-7e29-4254-bc47-38406796a9d8",
    content: "Sound 3",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/05/06/task/sound-3.wav` },
  },
];

const groups = [
  { id: "3ef613fc-eaf4-471e-bd7d-28c56b743938", content: "A", options: {} },
  { id: "8440c208-8264-48b7-aa8e-dd41be524198", content: "B", options: {} },
  { id: "2e77fd04-29f4-4c89-9f37-ab4352891718", content: "C", options: {} },
];

export const task: Task = {
  id: "2a53beed-1fb1-4597-9eda-73747edb053d",
  solutionType: "order",
  type: "orderLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "722bcb9a-e4a9-49a0-9b37-12c4f0e0b237",
    "8951ee3c-0ba3-4dea-9ee3-61f577cc5980",
    "57484a4d-7e29-4254-bc47-38406796a9d8",
  ],
};
